export default {"gitHash":"fcf9ffbe4a34f4a1751053973484913b307deedf","gitHashShort":"fcf9ffb","time":1680167419471,"platform":"linux","arch":"x64"};